import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section} from 'components/UIKit';
import {BuyerFAQ, SellerFAQ} from './components';
import styles from './frequently-asked-questions.scss';
import * as locales from './locales';

interface FrequentlyAskedQuestionsProps {}

export function FrequentlyAskedQuestionsComponent({
  i18n,
}: WithI18nProps & FrequentlyAskedQuestionsProps) {
  return (
    <Section
      heading={i18n.translate('heading')}
      subhead={i18n.translate('subhead')}
      headingProps={{align: 'center'}}
      subheadProps={{align: 'center'}}
      headerSpacing="medium"
    >
      <div className={styles.faq}>
        <BuyerFAQ />
        <SellerFAQ />
      </div>
    </Section>
  );
}

export const FrequentlyAskedQuestions = withI18n({
  id: 'FrequentlyAskedQuestions',
  fallback: locales.en,
})(FrequentlyAskedQuestionsComponent);
